import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initAuth } from '@/lib/auth-init';
import '@/styles/globals.css';

// Initialize Supabase auth listener before rendering
// (settings hydration happens inside initAuth after session resolves)
void initAuth();

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
